import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/icons/NewLogo.png';
import '../../../styles/SplashScreen.css';
function SplashScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login');
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="splash-screen">
      <div className="splash-content">
        <img src={logo} alt="PrashaSync Logo" className="splash-logo" />
      </div>
    </div>
  );
}

export default SplashScreen;
